import { isPending } from '@devexperts/remote-data-ts'
import { useEffect } from 'react'
import {
  INSERT_DATA_PATH,
  INSERT_INSURANCE_PATH,
  MAP_PATH,
  SECTOR_PATH,
  TICKETS_PATH,
} from '@/app/router/paths'
import { useAppDispatch, useAppSelector } from '@/hooks/store.ts'
import { cartSlice } from '@/store/cartSlice'
import { extraSlice } from '@/store/extraSlice.ts'
import { insertPeriodSlice } from '@/store/insertPeriodSlice'
import { useCurrentPath } from './useCurrentPath'

export const useFetchPricePreview = () => {
  const dispatch = useAppDispatch()
  const period = useAppSelector(insertPeriodSlice.selectors.period)
  const weatherInsurancePrice = useAppSelector(
    extraSlice.selectors.weatherInsurancePricePreview
  )
  const { currentPath } = useCurrentPath()
  const amount = useAppSelector(cartSlice.selectors.totalWithoutFees)

  // in map/sector/ticket path we only need to know if there's a weatherInsurance
  // available for that period or not, so we know if insertInsurance is the next step after selecting spots/tickets
  // we don't need to re-fire this API call every time the user adds/removes something from their cart
  useEffect(() => {
    if ([MAP_PATH, SECTOR_PATH, TICKETS_PATH].includes(currentPath)) {
      dispatch(extraSlice.actions.fetchWeatherInsurancePricePreview())
    }
  }, [period])

  // these are the pages where we need an updated insurance price every time the amount in cart changes
  // this is necessary since we need to show the user how much they will pay for their insurance and this
  // number changes according to the total cart value (minus service fees);
  useEffect(() => {
    if ([INSERT_INSURANCE_PATH, INSERT_DATA_PATH].includes(currentPath)) {
      dispatch(
        extraSlice.actions.fetchWeatherInsurancePricePreview({
          amount,
        })
      )
    }
  }, [amount])

  return isPending(weatherInsurancePrice)
}
